import { Switch } from "@mui/material";
import React, { useState } from "react";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import { pointsConfig } from "../../../pointsConfig";

function PointsCreateMissionBookingCount({
  bookingCount,
  onBookingCountChange,
  data,
  setData,
}) {
  const toggleFeature = (feature) => {
    const featureValue = bookingCount.find((item) => item.label === feature);
    if (!featureValue) {
      onBookingCountChange([
        ...bookingCount,
        { count: 0, label: feature, enabled: true },
      ]);
      return;
    }
    const toggleValue =
      !bookingCount.find((item) => item.label === feature)?.enabled || false;
    onBookingCountChange(
      bookingCount.map((item) =>
        item.label === feature ? { ...item, enabled: toggleValue } : item
      )
    );
  };

  const updateFeatureCount = (feature, count) => {
    onBookingCountChange(
      bookingCount.map((item) =>
        item.label === feature ? { ...item, count: Number(count) } : item
      )
    );
  };

  const options = [
    {
      title: "All",
      description: "This applies to flight, hotel, and tour bookings.",
      toggle: () => {
        toggleFeature("ALL");
      },
      noInput: true,
      code: "ALL",
      visible: true,
    },
    {
      title: "Flight",
      description: "This applies to only flight bookings.",
      toggle: () => {
        toggleFeature("FLIGHT");
      },
      code: "FLIGHT",
      visible: !bookingCount.find((item) => item.label === "ALL")?.enabled,
    },
    {
      title: "Hotel",
      description: "This applies to only hotel bookings.",
      toggle: () => {
        toggleFeature("HOTEL");
      },
      code: "HOTEL",
      visible: !bookingCount.find((item) => item.label === "ALL")?.enabled,
    },
    {
      title: "Tour",
      description: "This applies to only tour bookings.",
      toggle: () => {
        toggleFeature("TOUR");
      },
      code: "TOUR",
      visible: !bookingCount.find((item) => item.label === "ALL")?.enabled,
    },
  ];

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <div className="w-ful flex flex-col gap-4 mb-6">
        {options
          .filter((option) => option.visible)
          .map((option, index) => (
            <div className="w-full flex justify-between gap-2" key={index}>
              <div className="flex flex-1 flex-col">
                <span className="font-medium">{option.title}</span>
                <small className="text-[#6D7C94]">{option.description}</small>
              </div>
              {(!option.noInput ||
                bookingCount.find((item) => item.label === option.code)
                  ?.enabled) && (
                <input
                  type="number"
                  min={0}
                  value={
                    bookingCount.find((item) => item.label === option.code)
                      ?.count || 0
                  }
                  onChange={(e) => {
                    updateFeatureCount(option.code, e.target.value);
                  }}
                  className="w-20 border border-[#DBDBDB] rounded-md px-3 py-1"
                  placeholder="0"
                />
              )}
              <Switch
                checked={
                  bookingCount.find((item) => item.label === option.code)
                    ?.enabled || false
                }
                onChange={() => option.toggle()}
              />
            </div>
          ))}
      </div>
      <CommonDropdownInput
        label="Time Frame"
        value={data?.timeFrame}
        onChange={(val) => setData({ ...data, timeFrame: val })}
        options={pointsConfig.timeFrameOptions}
      />
      <CommonFreeTextInput
        value={Number(data?.pointsRewarded).toLocaleString()}
        label="Points Rewarded"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          setData({ ...data, pointsRewarded: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateMissionBookingCount;
